export const getExtensionImageUrl = (src: string): string => src;
